export const approvalInvoicesData = [
  {
    label: "Previously Uploaded Invoices",
    documentDetails: [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  },
  {
    label: "Updated Invoices",
    documentDetails: [{ name: "array", size: "178kb" }],
  },
];

export const RandomBoxShadows = [
  "0px 2px 10px rgba(255, 149, 81, 0.5)",
  "0px 2px 10px rgba(89, 206, 143, 0.5)",
  "0px 2px 10px rgba(89, 206, 143, 0.5)",
  "0px 2px 10px rgba(57, 106, 242, 0.5)",
  "0px 2px 10px rgba(77, 116, 240, 0.5)",
  "0px 2px 10px rgba(93, 214, 108, 0.5)",
  "0px 2px 10px rgba(45, 170, 99, 0.5)",
];
